<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">P/O で検出</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load" class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn @click="submit" class="mr-2">{{$t('app.buttons.apply')}}</v-btn>
        <v-btn @click="show = false" class="mr-2">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.poNo')" v-model="poNo"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.ivNo')" v-model="ivNo"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.bu.name')" v-model="ivNo"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.lotNo')" v-model="ivNo"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.skuCode')" v-model="ivNo"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.skuSupplierCode')" v-model="ivNo"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="invoices"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="seq"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td width="20">
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.itemNo }}</td>
          <td>{{ props.item.poNo }}</td>
          <td>{{ props.item.ivNo }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.netWeight }}</td>
          <td>{{ props.item.grossWeight }}</td>
          <td>{{ props.item.unitPrice }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    poNo: null,
    ivNo: null,
    selected: [],
    invoices: [],
    headers: [
      { text: 'P/O NO', value: 'poNo', sortable: false },
      { text: '事業本部', value: 'ivNo', sortable: false },
      { text: '事業部', value: 'qty', sortable: false },
      { text: 'Lot No', value: 'netWeight', sortable: false },
      { text: '社内品番', value: 'grossWeight', sortable: false },
      { text: '社外品番', value: 'grossWeight', sortable: false },
      { text: '発注数', value: 'grossWeight', sortable: false },
      { text: 'INV発行残', value: 'grossWeight', sortable: false }
    ]
  }),
  methods: {
    mounted() {
      this.load()
    },
    load() {
      this.$http.get('/shipping-advice-invoices').then(res => {
        this.invoices = res.data.content
      })
    },
    submit() {
      this.show = false
      this.$emit('submit', {
        containerNo: this.no,
        containerSize: this.size
      })
    },
    popup() {
      this.show = true
      this.load()
    }
  }
}
</script>
